export const PRODUCT_UNITS = {
  kg: [
    {
      name: "g",
      conversion: 1000,
    },
  ],
  l: [
    {
      name: "cl",
      conversion: 100,
    },
  ],
};

export const PRODUCT_KEY_ID_SEPARATOR = "___";
export const SECTION_UPDATE_INTERVAL = 60000;

export const OFFER_SECTION_KEY = "OFFERS";
export const BNGM_PREFIX = "BNGM";
export const BNGM_SLOT_SEPARATOR = "_SLOT_";
export const OFFER_SECTION = {
  description: "Retrouvez toutes nos offres du moment",
  position: 0,
  key: OFFER_SECTION_KEY,
  minimumPrice: 0,
  name: "Nos Offres",
  iconUrl: "/assets/thresholdMarketing.png",
  hidden: false,
  products: {},
};
